import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import rootReducer from './reducers';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['accessToken', 'userProfile', 'userCards','kudzuFlowFrom', 'isLoggedIn','climbPopShowValue', 'selectedCardDetails', 'ssnScreenThrough', 'savingsTermsConditions', 'selectedSubIndex', 'cancelTransactionDetails','kudzuPlusTrue','ShowPromptsTrue','isSignUpKudzuplusTrueData','isSignUpKudzuplusTrue','isSignKudzuplusTrial','isSignUpKudzuplusTrial','handlewelcomeCarouselSkipClick','welcomeCarouselSkipValue','loggedInResponse','preferredIdentity','climbFeatures','savingGoalResponseData','frequecyData', 'cbkTransactionDetails', 'manageSavingGoalDetailsObj', 'selectedFrequencyValue', 'manageSavingTotalCount ', 'fromSmiOne', 'smiOneId','smiOneAccountTrue','preferredName'],
};

// Create the persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
const store = createStore(persistedReducer);

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };
